import type { ApiSearchQuery } from '@/lib/api/api-type-helper';
import { ALL_TASK_TAB } from '../-constants';
type OperationTaskApiStatus = NonNullable<ApiSearchQuery<'/v2/self-service/tasks', 'get'>['status']>;
type OperationTaskListMode = NonNullable<ApiSearchQuery<'/v2/self-service/tasks', 'get'>['listMode']>;
const operationTaskStatusTabs = {
  NOT_STARTED: 'NotStarted',
  IN_PROGRESS: 'InProgress',
  WAITING_APPROVAL: 'WaitingApproval',
  COMPLETED: 'Completed'
} as const satisfies Record<string, OperationTaskApiStatus>;
export const OperationTaskTab = {
  ...operationTaskStatusTabs,
  ALL: ALL_TASK_TAB
} as const;
export type OperationTaskTab = (typeof OperationTaskTab)[keyof typeof OperationTaskTab];

/** @deprecated URL 後方互換用。InProgress にマップされる */
export const LEGACY_OPERATION_TASK_TAB_ACTIVE = 'active' as const;
export function toOperationTaskApiParams(tab?: OperationTaskTab): {
  listMode: OperationTaskListMode;
  status?: OperationTaskApiStatus;
} {
  if (!tab || tab === OperationTaskTab.ALL) {
    return {
      listMode: 'All'
    };
  }
  return {
    listMode: 'ByStatus',
    status: tab
  };
}